import { Box, IconButton, Typography } from "@mui/material";
import {
  Button,
  Color,
  Modal,
  SimpleInput,
} from "@axismaxlife/unified-ui-components-library";
import { CloseIcon } from "@axismaxlife/unified-ui-components-library/dist/systemIcons";
import { useEffect, useState } from "react";
import { String } from "../constants/Strings";
import { toAlphabets } from "../logic/CommonFunctions";
import { AppToast } from "./AppToast";
import { colors } from "../style/color/colors";
import { fonts } from "../style/fonts/fonts";

const EMPTY_DEPENDANT = { name: "", age: "" };

const toDigits = (raw) => `${raw ?? ""}`.replace(/[^0-9]/g, "");
const toText = (raw) => (raw === null || raw === undefined ? "" : `${raw}`);

const toFormState = (value) =>
  value
    ? { name: toText(value.name), age: toText(value.age) }
    : EMPTY_DEPENDANT;

export const DependantDetailsModal = ({
  isOpen,
  onClose,
  onSave,
  initialValue,
}) => {
  const [dependant, setDependant] = useState(EMPTY_DEPENDANT);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastKey, setToastKey] = useState(0);

  const showNameError = () => {
    setToastOpen(true);
    setToastKey((k) => k + 1);
  };

  useEffect(() => {
    if (isOpen) {
      setDependant(toFormState(initialValue));
      setToastOpen(false);
    }
  }, [isOpen]);

  const isValid = Boolean(`${dependant.name}`.trim() && dependant.age);

  const handleSave = () => {
    onSave({ name: `${dependant.name}`.trim(), age: Number(dependant.age) });
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      device="mobile"
      variant="bottom sheet"
      showCloseIcon
      className="acr-details-modal"
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: "12px",
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize: "20px",
              fontFamily: fonts.manrope,
              fontWeight: 700,
              color: colors.NeutralDark700,
            }}
          >
            {String.ChildPlannig.enterDependentDetails}
          </Typography>
          <IconButton
            sx={{ p: 0, flexShrink: 0 }}
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon size="small" fillColor={Color.Icons.Default} />
          </IconButton>
        </Box>
        <SimpleInput
          name="dependantName"
          width="100%"
          label={String.ChildPlannig.namePlaceholder}
          placeholder={String.ChildPlannig.namePlaceholder}
          value={dependant.name}
          onChange={(e) =>
            setDependant((prev) => ({
              ...prev,
              name: toAlphabets(e.target.value, showNameError),
            }))
          }
        />
        <SimpleInput
          name="dependantAge"
          type="text"
          inputMode="numeric"
          width="100%"
          label={String.ChildPlannig.agePlaceholder}
          placeholder={String.ChildPlannig.agePlaceholder}
          value={dependant.age}
          onChange={(e) =>
            setDependant((prev) => ({
              ...prev,
              age: toDigits(e.target.value).slice(0, 3),
            }))
          }
        />
        <Box sx={{ mt: "8px" }}>
          <Button
            buttonType="primary"
            width="100%"
            disabled={!isValid}
            onClick={handleSave}
          >
            {String.ChildPlannig.saveDetails}
          </Button>
        </Box>
        <AppToast
          key={toastKey}
          open={toastOpen}
          message="Name cannot be a number"
          severity="error"
          handleClose={() => setToastOpen(false)}
        />
      </Box>
    </Modal>
  );
};
